// extracted by mini-css-extract-plugin
export default {"listItem":"_6eUzzJ0jRkQrCOVcvLeY4w","link":"_5ZFvb9Y3tsJKqHp4LPCwUa"};